import React, {useRef, useState} from "react";
import {Button} from "@material-ui/core";
import ReactToPrint from "react-to-print";
import {useLocalStorage} from "@rehooks/local-storage";
import {Word} from "../models/models";
import "./PrintListComponent.scss"



class ComponentToPrint extends React.Component<{ words: Word[], showDeleteButton: boolean, handleDelete: (wordId: number) => void }> {
	render() {
		return (
			<div>
				{
					this.props.words.map(w =>
						<div key={w.id} className="page-break" style={{border: "1px solid gray", padding: "30px", marginBottom: "30px"}}>
							{this.props.showDeleteButton &&
                            <Button color="secondary" style={{
								float: "right"
							}} onClick={(e) => this.props.handleDelete(w.id)}>제외</Button>}
							<span>[{w.dictionaryGroup}] - [{w.dictionary}]</span>
							<h2 style={{textAlign: "center", marginBottom: "50px"}} className="term">{w.term}</h2>
							{React.createElement("div", {dangerouslySetInnerHTML: {__html: w.description}})}
						</div>
					)
				}
			</div>
		)
	}
}


export const PrintListComponent: React.FC<any> = () => {
	const componentRef = useRef();


	const [printWords, setPrintWords, deletePrintWords] = useLocalStorage<Word[]>('printWords', []);
	const [showDeleteButton, setShowDeleteButton] = useState(true);


	return (
		<>
			<ReactToPrint
				onBeforeGetContent={() => setShowDeleteButton(false)}
				onAfterPrint={() => setShowDeleteButton(true)}
				trigger={() => <Button variant="contained" color="primary">인쇄하기</Button>}
				// @ts-ignore
				content={() => componentRef.current}
			/>

			<Button variant="contained"
			        color="secondary"
			        onClick={() => {
				        if (window.confirm("인쇄 용어 목록을 전체 비우시겠습니까?")) {
					        setPrintWords([]);
				        }
			        }}
			        style={{float: "right"}}>
				전체 비우기
			</Button>

			<br/>
			<br/>
			<br/>

			<ComponentToPrint
				words={printWords}
				showDeleteButton={showDeleteButton}
				handleDelete={(wordId) => setPrintWords(printWords.filter(pw => pw.id !== wordId))}
				// @ts-ignore
				ref={componentRef}/>
		</>
	)
};